import { Typography } from '@mui/material'
import { CarrierVisitStatus } from '@planning/app/api'
import { CarrierVisitStatusChip } from '@planning/components/CarrierVisitStatusChip'
import { useTranslate } from '@tolgee/react'
import { EmptyIndicator, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

type RailVisitInformationProps = {
  inboundTripId?: string[] | null
  outboundTripId?: string[] | null
  operator?: string | null
  status: CarrierVisitStatus
}

export const RailVisitInformation = observer((props: RailVisitInformationProps) => {
  const { inboundTripId, outboundTripId, operator, status } = props
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  return (
    <>
      <Typography variant='body2' color={theme.palette.text.secondary}>
        {t('operator', 'Operator')}: {operator ?? EmptyIndicator}
      </Typography>

      <Typography variant='body2' color={theme.palette.text.secondary}>
        {t('tripIdsIn', 'Trip IDs In')}: {inboundTripId?.join(', ') ?? EmptyIndicator}
      </Typography>

      <Typography variant='body2' color={theme.palette.text.secondary}>
        {t('tripIdsOut', 'Trip IDs Out')}: {outboundTripId?.join(', ') ?? EmptyIndicator}
      </Typography>

      <CarrierVisitStatusChip status={status} />
    </>
  )
})
